import React from 'react';
import { Control, Controller } from 'react-hook-form';

import Input from '@ott/input';
import { l10n } from '@ott/l10n';

import { FORM_FIELDS } from '../../helpers/constants';
import { RefillFormType } from '../../types';
import { parseCVV, formatCVV } from './helpers/transforms';

import styles from './CVVField.scss';

type Props = {
  disabled: boolean;
  control: Control<RefillFormType, object>;
};

const CVVField = ({ disabled, control }: Props) => {
  return (
    <div className={styles.cvvWrapper}>
      <Controller
        name={FORM_FIELDS.cvv}
        control={control}
        render={({ field, fieldState }) => (
          <Input
            {...field}
            hasError={fieldState.invalid}
            placeholder={l10n('virtualCard.refillForm.fields.cvv')}
            type="password"
            isDisabled={disabled}
            parser={parseCVV}
            formatter={formatCVV}
            autoComplete="cc-csc"
            maxLength={4}
          />
        )}
      />
    </div>
  );
};

export default React.memo(CVVField);
